import React, { FC } from 'react';
import './AgentTargetForm.css';
import {
	InputField,
	SelectField,
	RequiredNote,
	FaUser,
	FaCalendarAlt,
	FaBullseye,
	DomainFormProps,
	SoNumber
} from '@/Shared';

/**
 * =====================================================
 * Component: AgentTargetForm
 * =====================================================
 *
 * Domain-specific form UI for managing Agent Targets.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render contact fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const AgentTargetForm: FC<DomainFormProps> = ({ domainFormHook, formRef,formikProps }) => {

	const { entityFormVM } = domainFormHook;
	const { setFieldValue } = formikProps;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (
		<div className="fieldset-wrapper">
			<fieldset className='width-30'>
				<legend>Agent & Année</legend>
				<SelectField
					label='Agent'
					required
					icon={<FaUser />}
					name='agentId'
					options={entityFormVM.agentOptions}
					scrollParent={formRef.current}
				/>

				<InputField
					label='Année'
					required
					name='year'
					type='number'
					placeholder='Ex: 2026'
					min={2000}
					max={2500}
					step={1}
					autoComplete='off'
					icon={<FaCalendarAlt />}
				/>
				<RequiredNote />
			</fieldset>
			<fieldset className='width-30'>
				<legend>Cibles Agent</legend>

				<InputField
					label='Objectif Location'
					name='rentalTarget'
					type='number'
					placeholder='Ex: 10'
					autoComplete='off'
					icon={<FaBullseye />}
				/>

				<InputField
					label='Objectif Vente'
					name='salesTarget'
					type='number'
					placeholder='Ex: 5'
					autoComplete='off'
					icon={<FaBullseye />}
				/>

				<InputField
					label='Objectif Autres Produits'
					name='otherProductsTarget'
					type='number'
					placeholder='Ex: 3'
					autoComplete='off'
					icon={<FaBullseye />}
				/>

				<InputField
					label='Objectif CA'
					name='caTarget'
					type='text'
					placeholder='Ex: 100 000'
					autoComplete='off'
					icon={<FaBullseye />}
					onChange={  (e) => setFieldValue(
							'caTarget', 
							SoNumber.formatAmount(e.target.value)
						)
					}
				/>

				<InputField
					label='Objectif Mandats'
					name='mandatesTarget'
					type='number'
					placeholder='Ex: 2'
					autoComplete='off'
					icon={<FaBullseye />}
				/>
			</fieldset>
		</div>
	);
}

export default AgentTargetForm;
